import { render, staticRenderFns } from "./MarketData.vue?vue&type=template&id=7107d053&scoped=true"
import script from "./MarketData.vue?vue&type=script&lang=js"
export * from "./MarketData.vue?vue&type=script&lang=js"
import style0 from "./MarketData.vue?vue&type=style&index=0&id=7107d053&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7107d053",
  null
  
)

export default component.exports